/* eslint-disable indent */
import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { NavLink } from 'react-router-dom';

import './index.scss';

Modal.setAppElement('#root');

class InstallLayover extends React.Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.sendEailPreference = this.sendEailPreference.bind(this);
    this.copyCode = this.copyCode.bind(this);
    this.state = {
      email: '',
      copied: false,
    };
  }
  componentWillReceiveProps(nextProps) {
    if (
      !nextProps.webchatconfig.getEmailInst &&
      nextProps.webchatconfig.getEmailInst !==
        this.props.webchatconfig.getEmailInst
    ) {
      this.closeModal();
    }
  }
  closeModal() {
    this.props.closeInstallModal();
    this.setState({
      copied: false,
    });
  }
  sendEailPreference() {
    this.props.postWebchatEmails(
      this.state.email,
      this.props.business.id,
      this.props.business.info.EMAIL,
    );
  };
  handleChange = (event) => {
    this.setState({
      email: event.target.value,
    });
  };

  
  getWidgetScript = (domain) => {
    if (domain !== 'DENTAL') {
      return `<script defer="defer" src="https://chat-widget-v1.tl.getweave.com/js/init.js" data-client-id="${this.props.business.id}"></script>`;
    } else {
      return `<script src="https://dental-chat-widget-v1.tl.getweave.com/main.js" data-client-id="${this.props.business.id}"></script>`;
    }
  };
  copyCode() {
    const el = this.textArea;
    el.select();
    document.execCommand('copy');
    el.select();
    this.setState({
      copied: true,
    });
  };
  validateEmail = (email) => {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    console.log('validate emial', re.test(email));
    return re.test(email);
  };
  getWordpressLink = (domain) => {
    if (domain === 'DENTAL') {
      return window.Config.WEBCHAT_CONFIG.DENTAL_WORDPRESS_INSTRUCTION;
    } else {
      return window.Config.WEBCHAT_CONFIG.WORDPRESS_INSTRUCTION;
    }
  };
  getHeaderText=(domain)=>{
    if(domain === 'DENTAL'){
      return 'Web to Text';
    }else{
      return 'Web Chat';
    }
  }
  render() {
    const { modelopen, webchatconfig, domain } = this.props;
    const { copied } = this.state;
    console.log(this.props);
    return (
      <div>
        <Modal
          isOpen={modelopen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.closeModal}
          className="Modal"
          overlayClassName="Overlay"
          contentLabel="Example Modal"
        >
          <div>
            <div className="modal-header">
              <div className="title">Install {this.getHeaderText(domain)}</div>
              <button className="modal-close" onClick={this.closeModal}>
                X
              </button>
              <div className="guidelines">
                Copy and paste the code snippet below on one or many pages on
                your website, where you'd like the TrueLark {this.getHeaderText(domain)} to appear.
              </div>
              <div className="guidelines">
                Once you’ve completed your changes, open your website. Your web
                chat should appear in the bottom right corner.
              </div>
              <div className="copy-code">
                <textarea
                  className="code"
                  ref={(textarea) => (this.textArea = textarea)}
                  value={this.getWidgetScript(domain)}
                />
                <div
                  className="copy-btn"
                  onClick={this.copyCode}
                  style={{ backgroundColor: copied ? '#c4efe6' : '#E9EFF7' }}
                >
                  <i className="far fa-clone"></i>
                  {copied ? ' Copied' : ' Copy'}
                </div>
              </div>
              <div className="wordpress-link">
                Click{' '}
                <a href={this.getWordpressLink(domain)} target="_blank">
                  here
                </a>{' '}
                for WordPress instructions.
              </div>
              <div className="video-link">
                <a
                  href={window.Config.WEBCHAT_CONFIG.INSTALL_VIDEO}
                  target="_blank"
                >
                  <i className="fab fa-youtube"></i> Watch this video{' '}
                </a>
                <span>for more details!</span>
              </div>
              <div className="help-webchat">
                <div className="description">
                  Send instructions to your developer
                </div>
                <div className="query">
                  <input
                    type="email"
                    title="Please Provide A Valid Email Address"
                    placeholder="Email address"
                    value={this.state.email}
                    onChange={this.handleChange}
                    maxlength="100"
                  />
                  <button
                    className="btn btn--primary btn--lg"
                    onClick={this.sendEailPreference}
                    disabled={
                      webchatconfig.getEmailInst ||
                      !this.validateEmail(this.state.email)
                    }
                  >
                    {webchatconfig.getEmailInst ? 'SENDING' : 'SEND'}
                  </button>
                </div>
                {!this.validateEmail(this.state.email) &&
                  this.state.email.length > 0 && (
                    <div className="errormessage">
                      {' '}
                      please enter a valid email id
                    </div>
                  )}
                <div className="title">
                  <a href="mailto:support@truelark.com">Need help?</a>
                </div>
              </div>
            </div>
          </div>
          {this.props.children}
        </Modal>
      </div>
    );
  }
}

export default InstallLayover;
